import { render } from "./RiskBar.vue?vue&type=template&id=906122dc&scoped=true"
import script from "./RiskBar.vue?vue&type=script&lang=js"
export * from "./RiskBar.vue?vue&type=script&lang=js"

import "./RiskBar.vue?vue&type=style&index=0&id=906122dc&scoped=true&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-906122dc"]])

export default __exports__